// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"bd85e654","153":"ebff0785","248":"3069c1fb","258":"c709d094","312":"ff9e1eaa","443":"5a895e85","521":"3b268681","573":"68e6ea88","704":"1a00a44a","732":"0a2a1411","963":"6f19e80f"}[chunkId] + ".chunk.js";
};